export default class DiagnosisDataModel {
    diagnosisId: number;
    diagnosisCodeNumber: string;
    diagnosisCodeDescription: string;
}